import { css } from 'aphrodite';
import * as React from 'react';
import { WarningIcon } from '../../components/svgs/icons/WarningIcon';
import { Button } from '../Button';
import { Dialog, DialogBody, DialogFooter, DialogHeader, DialogPopup, DialogTitle } from '../Dialog';
import { styleSheet } from './styles';

type IProps = {
	open: boolean;
	title: string;
	description: React.ReactNode;
	isDeleting?: boolean;
	onClose: () => void;
	onConfirm: () => void;
	confirmLabel?: string;
	cancelLabel?: string;
	children?: React.ReactNode;
};

export const DeleteConfirmDialog = ({
	open,
	title,
	description,
	isDeleting = false,
	onClose,
	onConfirm,
	confirmLabel = 'Delete',
	cancelLabel = 'Cancel',
	children,
}: IProps) => {
	return (
		<Dialog
			open={open}
			onOpenChange={openState => {
				if (!openState && !isDeleting) onClose();
			}}
		>
			<DialogPopup showCloseButton={!isDeleting} styles={[styleSheet.popup]}>
				<DialogHeader>
					<div className={css(styleSheet.header)}>
						<WarningIcon className={css(styleSheet.warningIcon)} />
						<DialogTitle styles={[styleSheet.title]}>{title}</DialogTitle>
					</div>
				</DialogHeader>
				<DialogBody>
					<p className={css(styleSheet.description)}>{description}</p>
					{children}
				</DialogBody>
				<DialogFooter>
					<div className={css(styleSheet.buttonRow)}>
						<Button variant='destructive' onClick={onConfirm} isLoading={isDeleting}>
							{confirmLabel}
						</Button>
						<Button variant='secondary' onClick={onClose} disabled={isDeleting}>
							{cancelLabel}
						</Button>
					</div>
				</DialogFooter>
			</DialogPopup>
		</Dialog>
	);
};
